import Vue from 'vue'
import Brands from '../vue/brands.vue'
import Stickyfill from 'stickyfill'
import 'promise-polyfill/src/polyfill';

export default {
  init() {
    // JavaScript to be fired on the brands page

    new Vue({
      el: "#brand-grid",
      components: {
        Brands,
      },
    })

    let stickyElements = document.querySelectorAll('.sticky');

    for (var i = stickyElements.length - 1; i >= 0; i--) {
      Stickyfill.add(stickyElements[i]);
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/template-brands.js